export const FORM_ID = 'createEvent-form';
export const TITLE_MAX_LENGTH = 255;
export const DESCRIPTION_MAX_LENGTH = 2000;
export const REMINDERS_MAX_LENGTH = 5;

export enum ReminderTimeEnum {
  None = '',
  ZeroMinutes = '0',
  FiveMinutes = '5',
  TenMinutes = '10',
  HalfHour = '30',
  OneHour = '60',
  TwoHours = '120',
  OneDay = '1440',
  OneWeek = '10080',
  Custom = 'Custom',
}

export const ReminderMap = {
  [ReminderTimeEnum.None]: 'common_none',
  [ReminderTimeEnum.ZeroMinutes]: 'calendar_reminder_at_event',
  [ReminderTimeEnum.FiveMinutes]: 'calendar_reminder_5m',
  [ReminderTimeEnum.TenMinutes]: 'calendar_reminder_10m',
  [ReminderTimeEnum.HalfHour]: 'calendar_reminder_30m',
  [ReminderTimeEnum.OneHour]: 'calendar_reminder_1h',
  [ReminderTimeEnum.TwoHours]: 'calendar_reminder_2h',
  [ReminderTimeEnum.OneDay]: 'calendar_reminder_1d',
  [ReminderTimeEnum.OneWeek]: 'calendar_reminder_1w',
  [ReminderTimeEnum.Custom]: 'calendar_reminder_custom',
};

export enum RepeatEnum {
  NONE = 'NONE',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
  WorkingDays = 'WorkingDays',
  CUSTOM = 'CUSTOM',
}

export const RepeatMap = {
  [RepeatEnum.NONE]: 'common_none',
  [RepeatEnum.DAILY]: 'calendar_repeat_daily',
  [RepeatEnum.WorkingDays]: 'calendar_repeat_working_days',
  [RepeatEnum.WEEKLY]: 'calendar_repeat_weekly',
  [RepeatEnum.MONTHLY]: 'calendar_repeat_monthly',
  [RepeatEnum.YEARLY]: 'calendar_repeat_yearly',
  [RepeatEnum.CUSTOM]: 'calendar_recurrence_custom',
};
